import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-foreground-200" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block group">
              <span className="text-xl font-bold text-accent-400 font-heading group-hover:text-accent-300 transition-colors">
                🍉 黑料吃瓜网
              </span>
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              最新娱乐八卦热点聚合平台，每日实时更新娱乐圈最新动态、明星八卦与独家爆料。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-foreground-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-foreground-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-foreground-200"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">
              热门分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">
                  首页头条
                </Link>
              </li>
              <li>
                <Link to="/category/star-gossip" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">
                  最新八卦
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">
              联系我们
            </h4>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-accent-400 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-foreground-400">contact@heiliachigua.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-2-line text-accent-400 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-foreground-400">7×24小时在线</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黑料吃瓜网 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}